import { useNavigate, useParams } from "react-router-dom";
import Spinner from "../../../components/ui/spinner/Spinner";
import styles from "./styles/PosServices.module.css";
import { useContext, useEffect, useState } from "react";
import DataContext from "../../../context/DataContext";
import { axiosSW } from "../../../api/axiosDefaults";
import PosServicesForm from "./PosServicesForm";
import POSDataContext from "../../../context/POSDataContext";

/**
 * The services component for the POS
 */
const PosServices = () => {
    const { bUser } = useParams(); // Extracts 'bUser' parameter from the URL.
    const [services, setServices] = useState(null);
    const [notReadyView, setNotReadyView] = useState(true);

    const {
        isServiceDataAvailable, // {boolean} - Checks if the service data is available.
        serviceData, // {function} - Fetches the service data.
        currentBU, // {string} - Current business user.
        setIsLoading, // {function} - Sets the loading state.
        connection, // {object} - the clients settings
        isLoading, // {boolean} - Checks if the page is loading datacontext.
        JWTToken,
    } = useContext(DataContext);
    const {
        handleErrorPos, // {function} - Handles the error in the POS context.
        isLoadingPos, // {boolean} - Checks if the page is loading in the POS context.
        setIsLoadingPos, // {function} - Sets the loading state in the POS context.
    } = useContext(POSDataContext);
    const navigate = useNavigate(); // Hook for navigation in React Router.

    // Navigate to main page if the current business user is not available.
    // if avialable fetch the services.
    useEffect(() => {
        if (!currentBU) {
            navigate(`/${bUser}/pos`);
        } else {
            JWTToken && fetchServices();
        }
    }, [bUser, currentBU, JWTToken]);

    // Fetch the service data if the business user is available
    // and the service data is not available or the business user has changed.
    useEffect(() => {
        bUser &&
            JWTToken &&
            (!isServiceDataAvailable || bUser !== currentBU) &&
            serviceData(bUser);
    }, [bUser, isServiceDataAvailable, JWTToken]);

    // Check ready for viewing
    useEffect(() => {
        if (isServiceDataAvailable && (!isLoadingPos || !isLoading)) {
            const timer = setTimeout(() => {
                setNotReadyView(false);
            }, 50);

            // Cleanup function
            return () => {
                clearTimeout(timer);
            };
        }
    }, [isServiceDataAvailable, isLoadingPos, isLoading]);

    // Fetch the services
    const fetchServices = async () => {
        setIsLoadingPos(true);
        try {
            const { data } = await axiosSW.get(
                `Service/pos/GetAvailableServices/${
                    connection?.uniqueIdentifier
                }`,
            );

            setServices(data?.services);
            setIsLoadingPos(false);
        } catch (error) {
            setIsLoadingPos(false);
            handleErrorPos(error);
        }
    };

    return (
        <article
            className={` transition-container 
                    ${
                        notReadyView
                            ? "transition-hidden"
                            : "transition-visible"
                    }  main-page-container flex-container`}
        >
            {isLoadingPos || isLoading ? (
                <Spinner />
            ) : (
                <main
                    className={`${styles.main_page_container} main-container flex-container`}
                >
                    <PosServicesForm services={services} />
                </main>
            )}
        </article>
    );
};

export default PosServices;
